import { APIENDPOINTS } from "@/api/services/moduleSettingsMaster/ApiEndPoint";
import { baseApi } from "@/utils/baseApi";

export const gradeApi = baseApi.injectEndpoints({

  endpoints: (builder) => ({
    fetchGrade: builder.query({
      query: () => ({
        url: APIENDPOINTS.FETCH_GRADE,
        method: "GET",
      }),
      providesTags: [{ type: "gradeDetails", id: "LIST" }],
    }),

    postGrade: builder.mutation({
      query: (formData) => ({
        url: APIENDPOINTS.POST_GRADE,
        method: "POST",
        body: formData,
      }),
      invalidatesTags: [{ type: "gradeDetails", id: "LIST" }],
    }),
    updateGrade: builder.mutation({
      query: ({ gradeId, formData }) => ({
        url: APIENDPOINTS.UPDATE_GRADE(gradeId),
        method: "PUT",
        body: formData,
      }),
      invalidatesTags: [{ type: "gradeDetails", id: "LIST" }],
    }),
    deleteGrade: builder.mutation({
      query: (gradeId) => ({
        url: APIENDPOINTS.DELETE_GRADE(gradeId),
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "gradeDetails", id: "LIST" }],
    }),
    updateGradeStatus: builder.mutation({
      query: (gradeId) => ({
        url: APIENDPOINTS.UPDATE_STATUS(gradeId),
        method: "PUT",
      }),
      invalidatesTags: [{ type: "gradeDetails", id: "LIST" }],
    }),
  }),
});

export const {
  useFetchGradeQuery,
  usePostGradeMutation,
  useUpdateGradeMutation,
  useDeleteGradeMutation,
  useUpdateGradeStatusMutation
} = gradeApi;
